import CheckIcon from '@mui/icons-material/Check'
import WarningIcon from '@mui/icons-material/Warning'
import { useAlert } from 'providers/AlertProvider'
import { ActionAlert, StyledSnackbar } from './Alert.styled'

export const Alert = () => {
  const { type, text, open, anchorPosition } = useAlert()

  return (
    <StyledSnackbar
      open={open}
      autoHideDuration={4000}
      anchorOrigin={anchorPosition}>
      <ActionAlert
        icon={
          type === 'success' ? (
            <CheckIcon fontSize='inherit' />
          ) : (
            <WarningIcon fontSize='inherit' />
          )
        }
        type={type}>
        {text}
      </ActionAlert>
    </StyledSnackbar>
  )
}
